<!-- @format -->

<app-student-study-event-summary
  [studyEvent]="studyEvent"
  [hasNoLocations]="hasNoLocations"
  [hasIrregularLocations]="hasIrregularLocations"
  [allStudyEventTeacherIds]="allStudyEventTeacherIds"
  [cancelledOrExcludedEventCount]="cancelledOrExcludedEventCount"
  [allEventsCancelledOrExcluded]="allEventsCancelledOrExcluded"
  [language]="language">
</app-student-study-event-summary>
@if (irregularEvents.length > 0) {
  <app-student-study-event-exceptions
    [irregularEvents]="irregularEvents"
    [studyEventLocationIds]="studyEvent.locationIds"
    [studyEventTeacherIds]="teacherIds"
    [language]="language">
  </app-student-study-event-exceptions>
}
